import axiosInstance from '../axiosInstance';
import { BaseService } from './baseService';
class ContactsService extends BaseService<Contact, 'contactID', 'contacts'> {
	constructor() {
		super('contactID', 'contact', 'contacts');
	}

	async importContacts(payload: ContactImportPayload) {
		const response = await axiosInstance.post(
			`app/contactImports`,
			payload,
		);
		return response.data;
	}

	async addMultipleContactsToGroups(payload: {
		contacts: {
			contactGroups: {
				groupID: number;
			}[];
		}[];
	}) {
		await axiosInstance.post('app/contacts/batch', payload);
	}

	async deleteMultipleContactsFromGroups(payload: {
		contacts: {
			contactGroups: {
				contactGroupID: number;
				delete: boolean;
			}[];
		}[];
	}) {
		await axiosInstance.post('app/contacts/batch', payload);
	}

	async export(options: { filters: string; columnsToExport: string[] }) {
		return axiosInstance.post(
			`/app/contacts/export${options.filters}`,
			{
				columnsToExport: options.columnsToExport,
			},
			{
				responseType: 'blob',
			},
		);
	}

	async pasteContacts(pastedContacts: string[]): Promise<{
		newContacts: Contact[];
		existingContacts: Contact[];
		rejectedContacts: string[];
	}> {
		const response = await axiosInstance.post(
			`/app/contacts/pasteContacts`,
			{
				pastedContacts: pastedContacts,
			},
		);

		return response.data.data.contacts;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new ContactsService();
